import { Auth } from 'aws-amplify';


// Returns the Cognito ID token — carries `email`, `cognito:username`,
// `cognito:groups`, and `aud` natively, which the API auth middleware
// validates. Access tokens were used historically but lack `email` on
// Basic-tier user pools (V1 Pre-Token-Gen can't modify access tokens).
export const getAccessToken = async () => {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();
  return idToken;
};